import { SelectedGroup } from '../models/commonTypeScript';

export const SELECT_GROUP = 'SELECT_GROUP';
export interface SelectGroup extends SelectedGroup {
    type: typeof SELECT_GROUP;
}

export const selectGroup = (selectedGroup: SelectedGroup): SelectGroup => ({
    type: SELECT_GROUP,
    ...selectedGroup,
});

export const SELECT_GROUP_SUCCESS = 'SELECT_GROUP_SUCCESS';
export interface SelectGroupSuccess {
    type: typeof SELECT_GROUP_SUCCESS;
}

export const selectGroupSuccess = (): SelectGroupSuccess => ({ type: SELECT_GROUP_SUCCESS });
